(ns practitest.frontend.forms3.run.new-issue-dropdown
  (:require
    [clojure.string :as str]
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.common.bugtrackers :as bugtrackers]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.i18n :refer [format-translation get-translation]]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.modal :as modal]
    [practitest.frontend.components.overlay2 :as overlay2]
    [practitest.frontend.components2.add-entities :as add-entities]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.dropdown :as dropdown]
    [practitest.frontend.components2.spinners :as spinners]
    [practitest.frontend.forms3.entity-form.traceability :refer [grid-options link-entities-dialog-options]]
    [practitest.frontend.forms3.entity-form.utils :refer [get-modal-title]]
    [practitest.frontend.forms3.run.events :as run-events]
    [practitest.frontend.forms3.run.subs :as run-subs]
    [practitest.frontend.issue.bugtracker :as bugtracker]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

(def ^:private link-issues-state-key :link-issues-state)

(defn new-issue-button [step-id run-id edit-permissions?]
  (reagent/with-let [expanded?  (reagent/atom false)
                     toggle!    (fn []
                                  (swap! expanded? not)
                                  (when @expanded?
                                    (mixpanel/track "Run Form Actions" {"Action" "New Issue Dropdown Opened"})))
                     hide!      #(reset! expanded? false)
                     fail-step! (fn []
                                  (re-frame/dispatch [::run-events/update-step-status step-id run-id "FAILED"]))]
    (let [current-project @(re-frame/subscribe [::subs/current-project])
          bugtracker-name (bugtracker/bugtracker-type current-project)]
      [:<>
       [overlay2/floating-ui-overlay
        {:on-request-close hide!
         :show? @expanded?
         :offset 0
         :placement "bottom-end"}
        [buttons/button
         {:tertiary? true
          :on-click toggle!
          :active? @expanded?
          :disabled? (not edit-permissions?)
          :class "new-issue-button"
          :text (get-translation "run.steps.new-issue"
                                 "New Issue")
          :icon [icons/mux-issues]
          :end-icon [icons/mux-chevron-down2]}]
        [dropdown/dropdown-menu-body {:offset 0
                                      :placement "bottom"}
         (when (some? bugtracker-name)
           [dropdown/dropdown-menu-item
            {:icon      (when-let [icon-fn (bugtracker/icons-map-by-bugtracker
                                             (keyword (str/lower-case bugtracker-name)))]
                          [icon-fn])
             :text      (format-translation
                          (get-translation "run.steps.report-bugtracker-issue" "Fail and Report %{bugtracker} Issue")
                          {:bugtracker (bugtrackers/get-label bugtracker-name)})
             :on-click  (fn [_]
                          (fail-step!)
                          (hide!)
                          (re-frame/dispatch [::run-events/report-bugtracker-issue step-id]))
             :mixpanel  ["Run Form Actions" {"Action" "Issue Created Fail and Issue"}]}])
         [dropdown/dropdown-menu-item
          {:icon [icons/mux-issues]
           :text (get-translation "run.steps.report-internal-issue"
                                  "Fail and Report Internal Issue")
           :disabled? (not (:allow_issue_creation current-project))
           :on-click (fn [e]
                       (.preventDefault e)
                       (fail-step!)
                       (re-frame/dispatch [::router/push-state :practitest.frontend.issues/new
                                          {:project-id @(re-frame/subscribe [::subs/current-project-id])}
                                          {"from_step_id" step-id}]))
           :mixpanel ["Run Form Actions" {"Action" "Issue Created Fail and Internal"}]}]
         [dropdown/dropdown-menu-item
          {:icon [icons/mux-link2]
           :text (get-translation "run.steps.link-existing-issue"
                                  "Fail and Link Existing Issue (Search)")
           :on-click (fn [_]
                       (fail-step!)
                       (hide!)
                       (re-frame/dispatch [::run-events/set-link-issues-target-step step-id])
                       (re-frame/dispatch [::common-events/toggle-link-entities-modal
                                           :issue
                                           link-issues-state-key
                                           ::common-events/fetch-entity-list
                                           nil]))
           :mixpanel ["Run Form Actions" {"Action" "Issue Linked Search"}]}]
         [dropdown/dropdown-menu-item
          {:icon [icons/mux-link2]
           :text (get-translation "run.steps.link-existing-issue-by-id"
                                  "Fail and Link Existing Issue (by ID)")
           :on-click (fn [_]
                       (fail-step!)
                       (hide!)
                       (re-frame/dispatch [::run-events/set-link-issues-target-step step-id])
                       (re-frame/dispatch [::run-events/show-link-issue-by-id-modal]))
           :mixpanel ["Run Form Actions" {"Action" "Issue Linked Type"}]}]]]])))

(defn link-existing-issue-modal [target-step show? hide!]
  (reagent/with-let [issue-id (reagent/atom "")]
    (let [step-id  (:id target-step)
          position (get-in target-step [:attributes :position])
          error    @(re-frame/subscribe [::run-subs/link-issue-by-id-error])
          linking? @(re-frame/subscribe [::subs/progress? ::run-events/link-existing-issue])]
      [modal/bootstrap-modal
       {:is-open?         show?
        :on-request-close hide!
        :class            "link-issue-modal"
        :close-button?    (not linking?)
        :centered?        true}
       ;; header
       [:div.title
        (get-translation "run.steps.link-issue-modal.title" "Link Existing Issue (Type ID)")]
       ;; body
       [:div.link-existing-issue-modal-body
        [:p.link-existing-issue-modal-subtitle
         (format-translation
           (get-translation "run.steps.link-issue-modal.subtitle" "Link an existing bug to Step %{position}")
           {:position position})]
        [:div.link-existing-issue-modal-label (get-translation "run.steps.link-issue-modal.issue-id" "Issue ID")]
        [:div.input-with-message-container
         [:input.m-input
          {:type        "text"
           :class       (dom/classes-pairs :errors (some? error))
           :value       @issue-id
           :placeholder (get-translation "run.steps.link-issue-modal.placeholder" "Enter Issue ID (e.g., BUG-123, JIRA-456)")
           :auto-focus  true
           :on-change   (fn [e]
                          (reset! issue-id (.. e -target -value))
                          (when error
                            (re-frame/dispatch [::run-events/clear-link-issue-by-id-error])))}]
         [:div.validation-error-message error]]]
       ;; footer
       [:div.link-existing-issue-modal-footer
        [buttons/button
         {:text     (get-translation "generic.button.cancel" "Cancel")
          :disabled? (or linking? (not show?))
          :on-click hide!}]
        [buttons/button
         {:primary?  true
          :disabled? (or (str/blank? @issue-id) linking? (not show?))
          :text      (get-translation "run.steps.link-issue-modal.button" "Link Issue")
          :end-icon  (when linking? [spinners/mux-spinner {:size :small :inside? true}])
          :on-click  (fn []
                       (re-frame/dispatch [::run-events/link-existing-issue step-id @issue-id]))}]]])))

(defn- link-issues-dialog-props [target-step]
  (let [position      (get-in target-step [:attributes :position])
        step-name     (get-in target-step [:attributes :name])
        linked-ids    (set (map #(-> % :issue :id) (get-in target-step [:attributes :linked-issues])))
        disabled-row? (fn [row] (contains? linked-ids (:id row)))]
    (merge
      (grid-options
        {:state-key                  link-issues-state-key
         :table-id-suffix            "issues-grid"
         :current-entity             :run
         :linked-entity-type         :issue
         :linked-entities-key-plural :issues}
        disabled-row?)
      (link-entities-dialog-options
        {:state-key           link-issues-state-key
         :link-event          ::run-events/link-selected-issues-to-step
         :default-filter-name (get-translation "issue.grid.all" "All Issues")
         :current-entity      :run
         :grid-entity         :issue})
      {:title (get-modal-title
                (get-translation "run.steps.link-issue-dialog.action" "Link Issues")
                (get-translation "run.steps.link-issue-dialog.to-step" "to Step")
                position
                step-name)
       :hide! #(re-frame/dispatch [::run-events/hide-link-issues-dialog link-issues-state-key])
       :disabled-row-tooltip (fn [_row]
                               (get-translation "run.steps.link-issue-already-linked"
                                                "This issue is already linked to this step"))
       :disabled-select-all-tooltip (get-translation "run.steps.link-issue-some-linked"
                                                     "Cannot select all issues because some of the issues already linked to this step")})))

(defn link-issues-dialog [_target-step]
  (let [container-ref (atom nil)]
    (fn [target-step]
      [:div {:ref #(reset! container-ref %)}
       [add-entities/add-entities-dialog container-ref (link-issues-dialog-props target-step)]])))